import moment from 'moment';
const mergeConsecutiveWeekendPairs = (weekendDays)=>{
    if (weekendDays.length === 0) {
        return weekendDays;
    }
    const result = [];
    const used = new Set();
    weekendDays.sort((a, b)=>a.startDate.getTime() - b.startDate.getTime());
    for(let i = 0; i < weekendDays.length; i += 1){
        if (!used.has(i)) {
            const current = weekendDays[i];
            let paired = false;
            if (current.day === 'saturday' && i + 1 < weekendDays.length) {
                const next = weekendDays[i + 1];
                const daysBetween = moment(next.startDate).diff(moment(current.startDate), 'days');
                if (next.day === 'sunday' && daysBetween === 1) {
                    used.add(i);
                    used.add(i + 1);
                    result.push({
                        startDate: current.startDate,
                        endDate: next.endDate,
                        day: 'saturday'
                    });
                    paired = true;
                }
            }
            if (!paired) {
                result.push(current);
            }
        }
    }
    return result;
};
export const weekendHighlightAsUIFormatForTemplate = (relativeDate, startDay, duration, includeSaturday, includeSunday)=>{
    if (includeSaturday && includeSunday) {
        return [];
    }
    const relativeDateStart = relativeDate.clone().startOf('day');
    const actualStartDate = relativeDateStart.clone().add(startDay, 'days');
    const actualEndDate = actualStartDate.clone().add(duration - 1, 'days');
    const shouldHighlightSaturday = !includeSaturday;
    const shouldHighlightSunday = !includeSunday;
    const daysDiff = actualEndDate.diff(actualStartDate, 'days');
    const weekendDays = [];
    for(let i = 0; i <= daysDiff; i += 1){
        const currentDate = actualStartDate.clone().add(i, 'days');
        const daysFromRelative = currentDate.diff(relativeDateStart, 'days');
        const templateDayOfWeek = (daysFromRelative % 7 + 7) % 7;
        if (templateDayOfWeek === 5 && shouldHighlightSaturday) {
            weekendDays.push({
                startDate: currentDate.clone().startOf('day').toDate(),
                endDate: currentDate.clone().endOf('day').toDate(),
                day: 'saturday'
            });
        } else if (templateDayOfWeek === 6 && shouldHighlightSunday) {
            weekendDays.push({
                startDate: currentDate.clone().startOf('day').toDate(),
                endDate: currentDate.clone().endOf('day').toDate(),
                day: 'sunday'
            });
        }
    }
    if (shouldHighlightSaturday && shouldHighlightSunday && weekendDays.length > 0) {
        return mergeConsecutiveWeekendPairs(weekendDays);
    }
    return weekendDays;
};
